import moment from "moment";
import { FaCheckCircle } from "react-icons/fa";
import IReservationProps from "components/Reservation/IReservationProps";

import "./Reservation.css";

const Reservation: React.FC<IReservationProps> = ({ reservation, selected, OnClick }) => {
	const timeInizio = moment(reservation.Da).format("LT");
	const timeFine = moment(reservation.A).format("LT");

	return (
		<div className={`reservation${selected ? " reservation-selected" : ""}`}>
			<FaCheckCircle className={`icon-selected${selected ? "" : " icon-selected-hidden"}`} />
			<div className="reservation-content" onClick={() => OnClick(reservation)} 
			onKeyDown={(event) =>{ if (event.key === "Enter") {OnClick(reservation)}}}
			role="button" tabIndex={0}
			>
				<div className="reservation-time">
					<div className="span-container">
						<span>{`${timeInizio} - ${timeFine}`}</span>
					</div>
				</div>
				{!reservation.Professionista.Generico && (
					<div className="reservation-name">
						<span>{reservation.Professionista.DsOperatore}</span>
					</div>
				)}
			</div>
		</div>
	);
};

export default Reservation;
